
        import * as module0 from '$components/scheme_selector.js'
        const modules = {
            "scheme_selector.js": module0,
        };
        export default modules;
      